"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ComparisonMode;
(function (ComparisonMode) {
    ComparisonMode["DayMinusOneAndDayMinusEight"] = "dayMinusOneAndDayMinusEight";
    ComparisonMode["DayMinusOneAndDayMinusTwo"] = "dayMinusOneAndDayMinusTwo";
    ComparisonMode["WeekMinusOneAndWeekMinusTwo"] = "weekMinusOneAndWeekMinusTwo";
})(ComparisonMode = exports.ComparisonMode || (exports.ComparisonMode = {}));
exports.ComparisonModeKey = {
    dayMinusOneAndDayMinusTwo: 'COMPARISON_MODE.DAY_MINUS_TWO',
    dayMinusOneAndDayMinusEight: 'COMPARISON_MODE.DAY_MINUS_EIGHT',
    weekMinusOneAndWeekMinusTwo: 'COMPARISON_MODE.WEEK_MINUS_TWO',
};
//# sourceMappingURL=comparison.mode.js.map